import React, { useCallback, useEffect } from 'react';
import { path } from 'js/utils/ramda.util';
import { useUserSelector } from 'js/store/hooks';
import { withPortlet, usePortletConfig } from 'js/components/system/Portlet';
import { componentService } from 'js/services/component.service';
import ContactPreferencesForm from './ContactPreferencesForm';
import { getContactPreferences } from './selector';
import { setPlayerTag } from './actions';
import reducer, { initialState } from './reducer';
import * as hooks from './hooks';
import { CONTACT_PREFERENCES } from './constants';

export const ContactPreferencesBare = () => {
    const config = usePortletConfig();
    const contactPreferences = useUserSelector(path(['userDetails', 'contactPreferences']));
    const { playerTags, tagsEnabled, promotional, account, thirdParty } = config;
    const { init } = hooks.usePortletActions();

    const setPlayerTagWith = useCallback((type) => {
        const { [type]: tag } = playerTags;

        if (tagsEnabled) {
            setPlayerTag(tag);
        }
    }, [playerTags, tagsEnabled]);

    const onSubmit = useCallback(() => setPlayerTagWith('submitted'), [setPlayerTagWith]);

    useEffect(() => setPlayerTagWith('visited'), [setPlayerTagWith]);
    useEffect(() => {
        init(getContactPreferences({ promotional, account, thirdParty }, contactPreferences));
    }, [promotional, account, thirdParty, contactPreferences, init]);

    return <ContactPreferencesForm {...{ onSubmit }} />;

};

export const ContactPreferences = withPortlet({
    forLoggedIn: true,
    parseCms: hooks.useParsePortletConfig,
    reducer,
    initialState
})(ContactPreferencesBare);

componentService.registerPageComponents({ [CONTACT_PREFERENCES]: ContactPreferences });
